import * as React from 'react';
import { ModuleProps } from 'src/utils/module-util';
import { GameCalendarComponent } from 'src/components/common/modules/v1/game-calendar-new/code-split/game-calendar-component';

const GameCalendarModule = (props: ModuleProps) => {
  return (
    <GameCalendarComponent
      {...props}
      mccidData={{
        ...props.mccidData,
      }}
    />
  );
};

export { GameCalendarModule };
